export default __webpack_public_path__ + "static/media/BF665B6F-5795-4934-9A12-628AB5FEF16A_1_105_c.3a64c166.jpeg";